import { Box, ButtonGroup } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DRAWER_WIDTH } from "../../../../features/home/HomeDrawer";
import { CustomButton } from "../customButton/CustomButton";

export const BannerContainer = styled(Box)({
  position: "fixed",
  marginLeft: "-16px",
  padding: "15px",
  bottom: 0,
  borderTopLeftRadius: "8px",
  borderTopRightRadius: "8px",
  width: `calc(100% - ${DRAWER_WIDTH}px)`,
  boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.12)",
  backgroundColor: "#ffffff",
  display: "flex",
  justifyContent: "space-between",
});

export const ActionButton = styled(CustomButton)({
  borderRadius: "20px",
  margin: "0px 10px",
});

export const GroupButton = styled(CustomButton)({
  borderRadius: "16px",
});

export const ActionButtonGroup = styled(ButtonGroup)({
  margin: 0,
  padding: 0,
});
